/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsXyVIcon20Solid = forwardRef('DataChartBarsXyVIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M2 3a1 1 0 0 1 1 1v12a1 1 0 0 0 1 1h14a1 1 0 1 1 0 2H4a3 3 0 0 1-3-3V4a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M6 9.913a1 1 0 0 1 1 1v3.337a1 1 0 1 1-2 0v-3.337a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M10 6.384a1 1 0 1 0-2 0v7.836a1 1 0 1 0 2 0V6.384Z" }),
        React.createElement("path", { d: "M15 3a1 1 0 0 1 1 1v10.22a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M13 8.624a1 1 0 1 0-2 0v5.596a1 1 0 1 0 2 0V8.624Z" })));
});
